import { Spinner } from '@tableau/tableau-ui';
import * as React from 'react';
import { Messages } from '../../gen-src/Localize';
import { makeTestId } from '../utils/Declarative';
import { ElemAttrs } from '../utils/HtmlAttrs';

export enum ActivitySpinnerSize {
  Large = 50,
  Small = 14
}

export interface ActivitySpinnerProps {
  /** When true, a lighter color will be used for the spinner. */
  onDarkBackground?: boolean;

  /** When true, a semi transparent underlay will be shown. This is useful when showing the spinner on non-white backgrounds. */
  shouldShowUnderlay?: boolean;

  /**
   * * `ActivitySpinnerSize.Large` sets the spinner size to 50x50 px
   * * `ActivitySpinnerSize.Small` sets the spinner size to 14x14 px
   * @default ```ActivitySpinnerSize.Large```
   */
  spinnerSize?: ActivitySpinnerSize;

  /** Test id to be attached to the spinner. '-Spinner' will be automatically added as a suffix. */
  testId: string;
}

/** An inline activity spinner */
export const ActivitySpinnerWidget = React.forwardRef<HTMLDivElement, ActivitySpinnerProps & ElemAttrs>(
  ({ onDarkBackground, shouldShowUnderlay, spinnerSize, testId, ...htmlProps }, ref) =>
    <Spinner
      alt={Messages.waitIndicatorLabel()}
      data-tb-test-id={makeTestId(testId, 'Spinner')}
      {...htmlProps}
      color={onDarkBackground ? 'light' : 'dark'}
      dimension={spinnerSize}
      ref={ref}
      showUnderlay={shouldShowUnderlay}
    />
);
ActivitySpinnerWidget.defaultProps = { spinnerSize: ActivitySpinnerSize.Large };
ActivitySpinnerWidget.displayName = 'ActivitySpinnerWidget';
